import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00008 14.0021C4.68497 14.0021 1.99756 11.3146 1.99756 7.99957C1.99756 4.68448 4.68497 1.99707 8.00008 1.99707C11.3151 1.99707 14.0025 4.68448 14.0025 7.99957",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00005 14.0021C11.3151 14.0021 14.0026 11.3146 14.0026 7.99957C14.0026 4.68448 11.3151 1.99707 8.00005 1.99707C4.68497 1.99707 1.99756 4.68448 1.99756 7.99957",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.3396 5.99902H13.5896Z",
			fill: "#0517F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.3396 5.99902H13.5896",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.34033 10.0005H13.3337",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6678 7.9994C10.6728 6.13613 10.1734 4.30624 9.22246 2.70386C8.97086 2.2666 8.5048 1.99707 8.00026 1.99707C7.4958 1.99707 7.02973 2.2666 6.77813 2.70386C4.85065 5.97138 4.85065 10.0281 6.77813 13.2956C7.03086 13.7319 7.4964 14.0012 8.0006 14.0025",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33256 7.9994C5.32754 6.13613 5.82696 4.30624 6.77788 2.70386C7.02948 2.2666 7.49554 1.99707 8.00001 1.99707C8.50454 1.99707 8.97061 2.2666 9.22221 2.70386C11.1497 5.97138 11.1497 10.0281 9.22221 13.2956C8.96948 13.7319 8.50394 14.0012 7.99968 14.0025",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExternal;
